import { useNavigate, useOutletContext, useParams } from "react-router-dom"
import { useFetchOrgSystemUsageQuery } from "../../../../redux/queries"
import { Brand, LoanOfficer } from "../../../../types"
import { LightBtn } from "../../buttons"
import { ChevronLeft } from "lucide-react"
import Invoice from "../../invoice"

interface OutletContext {
  profile: LoanOfficer
  brand: Brand
}

const BankInvoice = () => {
  let month = ""

  const navigate = useNavigate()

  const { _id = "" } = useParams<{ _id: string }>()

  console.log("_id", _id)

  const { profile, brand } = useOutletContext<OutletContext>()

  // Fetch system usage for each org
  const {
    data: systemUsage = [],
    isFetching: isFetchingUsage,
    isError: isErrorUsage
  } = useFetchOrgSystemUsageQuery(
    { orgId: profile?.org_id, month },
    { skip: !profile?.org_id }
  )

  const current = systemUsage.find(item => item.org_id === _id)

  console.log("current", current)

  const onClickBack = () => {
    navigate("/account/billing")
  }

  if (!current) {
    return null
  }

  return (
    <div className="p-6">
      <LightBtn onClick={onClickBack} text="base" size="sm">
        <ChevronLeft size={16} />{" "}
        <span className="inline-block px-1">Back</span>
      </LightBtn>
      <Invoice
        className="mt-8"
        companyName={brand?.name ?? ""}
        invoiceTimestamp={current.timestamp}
        usage={current.details}
      />
    </div>
  )
}

export default BankInvoice
